import { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../../../config/api";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import SubscribedTab from "./SubscribedTab";
import RegularLoader from "../../../../Component/Loader/RegularLoader";
import toast from "react-hot-toast";

function ProductCard({ product, index, onOrder, isPopular, navigate  }) {
  const [showAllFeatures, setShowAllFeatures] = useState(false);
  const [showAllCoverage, setShowAllCoverage] = useState(false);
  const [showAllBenefits, setShowAllBenefits] = useState(false);

  const FEATURE_LIMIT = 3;
  const COVERAGE_LIMIT = 3;
  const BENEFITS_LIMIT = 3;

  const category = product.categories?.[0];

  const features = product.features
    ? product.features.split("✔").map((f) => f.trim()).filter(Boolean)
    : [];

  const coverage = product.coverage
    ? product.coverage.split(".").map((c) => c.trim()).filter(Boolean)
    : [];

  const benefits = product.retailer_benifits
    ? product.retailer_benifits.split(".").map((c) => c.trim()).filter(Boolean)
    : [];


  const isFeatured = isPopular;

  const displayedFeatures = showAllFeatures ? features : features.slice(0, FEATURE_LIMIT);
  const displayedCoverage = showAllCoverage ? coverage : coverage.slice(0, COVERAGE_LIMIT);
  const displayedbenefits = showAllCoverage ? benefits : benefits.slice(0, BENEFITS_LIMIT);


  const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");

const isRetailerMobile =
  typeof window !== "undefined" &&
  window.innerWidth < 640 &&
  (authUser?.role === 5 || authUser?.role === 6);

  const handleSubscribe = async () => {
  try {
    const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");

    const res = await axios.get(
      `${BASE_URL}warranty/check-retailer-active-plan`,
      {
        params: {
          retailer_id: authUser?.id,
          package_id: product?.id,
        },
      }
    );

    const data = res.data;

    // ✅ Already subscribed
    if (data?.success && data?.has_active_plan) {
      toast.error(
        "You are already subscribed to this product. Please select a different product."
      );
      return;
    }

    // ✅ Not subscribed → go next
    if (data?.success && !data?.has_active_plan) {
      navigate("/ordersummery", {
        state: { company_product_id: product.company_product_id },
      });
    }

  } catch (err) {
    console.error(err);
    alert("Something went wrong");
  }
};

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1, ease: "easeOut" }}
      // ⚠️ NO overflow-hidden here — that's what was clipping the border-radius
      style={{
        position: "relative",
        zIndex: isFeatured ? 10 : 1,
        // Featured card shifts UP so it protrudes above siblings
        transform: isFeatured ? "translateY(-28px)" : "translateY(0px)",
        width: "100%",
      }}
    >
      {/* This inner div carries the visual card — border-radius + overflow-hidden here is safe
          because it's not the element being transformed */}
      <div
        style={{
          borderRadius: "20px",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
        className={`transition-all duration-300
          ${
            isRetailerMobile
              ? isFeatured
                ? "bg-gradient-to-br from-[#3b82f6] to-[#2563eb] text-white shadow-xl"
                : "bg-white/70 backdrop-blur-md border border-white/60 shadow-[0_10px_30px_rgba(0,0,0,0.08)] text-slate-800"
              : isFeatured
              ? "bg-[#4a5bf3] text-white shadow-2xl"
              : "bg-white text-slate-800 shadow-lg border border-slate-200"
          }`}
      >
        {/* Badge row */}
        <div
          className="flex justify-center"
          style={{
            paddingTop: isFeatured ? "32px" : "28px",
            paddingBottom: "8px",
            minHeight: isFeatured ? "72px" : "52px",
          }}
        >
          {isFeatured && (
            <span className="bg-yellow-400 text-yellow-900 text-xs font-extrabold px-5 py-1.5 rounded-full uppercase tracking-widest whitespace-nowrap">
              Most Popular
            </span>
          )}
        </div>

        {/* Title */}
        <div className="px-6 pb-2 text-center">
          <h3
            style={{ fontSize: isFeatured ? "20px" : "17px" }}
            className={`font-extrabold uppercase tracking-widest
              ${
                isRetailerMobile
                  ? isFeatured
                    ? "text-white"
                    : "text-slate-800"
                  : isFeatured
                  ? "text-white"
                  : "text-slate-800"
              }`}
          >
            { product.product_type}
          </h3>
          {/* <p className={`text-[11px] mt-1 font-medium line-clamp-2
            ${isFeatured ? "text-white/70" : "text-slate-400"}`}>
            {product.name}
          </p> */}
        </div>

        {/* Price Shape */}
        <div className="flex justify-center" style={{ margin: "10px 0" }}>
          <div
            className="flex flex-col items-center justify-center shadow-md"
            style={{
              width: isFeatured ? "100px" : "84px",
              height: isFeatured ? "100px" : "84px",
              background: "#f1f5f9",
              borderRadius: isFeatured
                ? "44% 56% 52% 48% / 46% 44% 56% 54%"
                : "50%",
            }}
          >
            <span
              style={{ fontSize: isFeatured ? "20px" : "18px", color: "#1e293b" }}
              className="font-extrabold leading-tight"
            >
              {product.is_percent === 1 ? `${product.mrp}%` : `₹${product.mrp}`}
            </span>
            <span className="text-[10px] uppercase tracking-widest font-semibold text-slate-400 mt-0.5">
              Per Plan
            </span>
          </div>
        </div>

        {/* Meta info */}
        <div className={`px-6 text-center leading-relaxed
          ${isFeatured ? "text-white/85" : "text-slate-500"}`}>
          <p className={`text-sm font-bold ${
            isRetailerMobile
              ? isFeatured
                ? "text-white/90"
                : "text-blue-600"
              : isFeatured
              ? "text-white"
              : "text-blue-600"
          }`}>
            {product.sub_val_days} Days &nbsp;·&nbsp; {product.enroll_max} Devices
          </p>
          {/* {product.min_value && (
            <p className="text-xs mt-1">
              ₹{product.min_value?.toLocaleString("en-IN")} – ₹{product.max_value?.toLocaleString("en-IN")}
            </p>
          )} */}
        
        </div>

        {/* Features */}
        {features.length > 0 && (
          <div className="px-6 mt-4">
            <p className={`text-[10px] font-bold uppercase tracking-widest mb-1.5
              ${isFeatured ? "text-white/60" : "text-slate-400"}`}>
              benefits
            </p>
            <ul className="space-y-1">
              {displayedbenefits.map((f, i) => (
                <li key={i} className={`flex items-start gap-1.5 text-[11px]
                  ${isFeatured ? "text-white/80" : "text-slate-600"}`}>
                  <span className={`flex-shrink-0 font-bold mt-0.5
                    ${isFeatured ? "text-yellow-300" : "text-blue-500"}`}>✔</span>
                  {f}
                </li>
              ))}
            </ul>
            {benefits.length > BENEFITS_LIMIT && (
              <button
                onClick={() => setShowAllBenefits(!showAllBenefits)}
                className={`text-[10px] font-bold mt-1.5
                  ${isFeatured ? "text-yellow-300" : "text-blue-600"}`}>
                {showAllBenefits ? "View Less ▲" : `+${benefits.length - BENEFITS_LIMIT} more ▼`}
              </button>
            )}
          </div>
        )}
        <div className="flex-1" />

        {/* CTA Button */}
        <div style={{ padding: isFeatured ? "20px 24px 36px" : "20px 24px 28px" }}>
          <button
            onClick={handleSubscribe}
            className={`w-full py-2 rounded-2xl font-extrabold text-sm uppercase tracking-widest
              transition-all duration-200 active:scale-95
              ${
                isRetailerMobile
                  ? isFeatured
                    ? "bg-white text-blue-700 shadow-lg"
                    : "bg-blue-600 text-white shadow-md"
                  : isFeatured
                  ? "bg-white text-[#2233CC] hover:bg-blue-50 shadow-lg"
                  : "bg-[#2233CC] text-white hover:bg-blue-800 shadow"
              }`}
          >
            Subscribe Now
          </button>
        </div>
      </div>
    </motion.div>
  );
}

export default function RetailerProductView() {
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);

  const [isOrderOpen, setIsOrderOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const authUserString = localStorage.getItem("authUserData");
  const authUser = authUserString ? JSON.parse(authUserString) : null;
  const companyId = authUser?.company_id;
  const retailerid = authUser?.id;

   const location = useLocation();

  const [activeTab, setActiveTab] = useState(
    location.state?.activeTab || "subscription"
  );
  const [subscribedProducts, setSubscribedProducts] = useState([]);

  const navigate = useNavigate()

  const isRetailerMobile =
  typeof window !== "undefined" &&
  window.innerWidth < 640 &&
  (authUser?.role === 5 || authUser?.role === 6);
 

   const mostPopularId = products.length
  ? products.reduce((max, p) =>
      Number(p.sold_count) > Number(max.sold_count) ? p : max
    ).id
  : null;

  useEffect(() => {
  if (location.state?.activeTab) {
    setActiveTab(location.state.activeTab);
  }
}, [location.state]);

  useEffect(() => {
    async function fetchProducts() {
      if (!companyId) return;
      setLoading(true);
      try {
        const res = await axios.get(`${BASE_URL}warranty/company-products`, {
          params: { company_id: companyId , is_offer: 1 },
        });
        const companyBlock = res.data?.data?.[0];
        const mapped =
          companyBlock?.products?.map((cp) => ({
            company_product_id: cp.company_product_id,
            margin: cp.margin,
            ...cp.product,
          })) || [];
        setProducts(mapped);
      } catch (e) {
        console.error("Company products error", e);
      } finally {
        setLoading(false);
      }
    }
    fetchProducts();
  }, [companyId]);


  if (loading) {
    return (
      <RegularLoader/>
    );
  }

  if (!products.length) {
    return (
      <div className="flex items-center justify-center py-5 text-slate-400 text-sm">
        No products available.
      </div>
    );
  }

  return (
    /* py-16 gives breathing room for the featured card's translateY(-28px) to protrude into */
    
    <div
      className={`px-6 py-2 min-h-screen ${
        isRetailerMobile
          ? ""
          : ""
      }`}
    >

      <div className="flex gap-3 mb-6">
        <button
          onClick={() => setActiveTab("subscription")}
          className={`px-4 py-1 rounded-xl text-sm font-semibold transition ${
            activeTab === "subscription"
              ? "bg-blue-600 text-white shadow"
              : "bg-white text-slate-600 border"
          }`}
        >
          Subscription
        </button>

        <button
          onClick={() => setActiveTab("subscribed")}
          className={`px-4 py-1 rounded-xl text-sm
             font-semibold transition ${
            activeTab === "subscribed"
              ? "bg-blue-600 text-white shadow"
              : "bg-white text-slate-600 border"
          }`}
        >
          Subscribed Products
        </button>
      </div>
     {/* 👇 CONDITIONAL RENDER */}
  {activeTab === "subscription" && (
    <div className="flex flex-wrap gap-5">
      {products.map((p, i) => (
        <div key={p.company_product_id} className="w-full sm:w-60">
          <ProductCard
            product={p}
            index={i}
            isPopular={p.id === mostPopularId}
            navigate={navigate}
          />
        </div>
      ))}
    </div>
  )}

  {activeTab === "subscribed" && (
  <SubscribedTab companyId={retailerid} />
)}

    </div>
  );
}


// *************************************************************original code without subscription********************************************************************

// import { useEffect, useState } from "react";
// import axios from "axios";
// import { BASE_URL } from "../../../../config/api";
// import { useContext } from "react";
// import { AuthContext } from "../../../../context/AuthContext";
// import { motion } from "framer-motion";


// function ProductCard({ product, isRetailerMobile }) {

//   const [showAllFeatures, setShowAllFeatures] = useState(false);
//   const [showAllCoverage, setShowAllCoverage] = useState(false);

//   const FEATURE_LIMIT = 2;
//   const COVERAGE_LIMIT = 2;
//   const category = product.categories?.[0];

//   const features = product.features
//   ? product.features.split(".").map((f) => f.trim()).filter(Boolean)
//   : [];

//   const coverage = product.coverage
//     ? product.coverage.split(".").map((c) => c.trim()).filter(Boolean)
//     : [];

//   const exclusions = product.exclusions
//     ? product.exclusions.split(".").map((e) => e.trim()).filter(Boolean)
//     : [];

//   const getTheme = () => {
//     const name = category?.name?.toLowerCase() || "";
//     if (name.includes("iphone")) return purpleTheme;
//     if (name.includes("android")) return blueTheme;
//     return emeraldTheme;
//   };

//   const blueTheme = {
//     gradient: "from-blue-500 to-blue-700",
//     accent: "border-blue-400",
//     check: "text-blue-600",
//     badge: "bg-blue-500",
//   };

//   const purpleTheme = {
//     gradient: "from-purple-500 to-purple-700",
//     accent: "border-purple-400",
//     check: "text-purple-600",
//     badge: "bg-purple-500",
//   };

//   const emeraldTheme = {
//     gradient: "from-emerald-500 to-emerald-700",
//     accent: "border-emerald-400",
//     check: "text-emerald-600",
//     badge: "bg-emerald-500",
//   };

//   const theme = getTheme();

//   return (

//     <motion.div
//   initial={{ opacity: 0, y: 30 }}
//   animate={{ opacity: 1, y: 0 }}
//   transition={{ duration: 0.6, ease: "easeOut" }}
//   className="..."
// >
//     <div
//       className={`relative w-full max-w-xs mx-auto rounded-2xl overflow-hidden transition-all duration-500 ${
//         isRetailerMobile
//           ? "glass-card bg-white/10 backdrop-blur-2xl border border-white/30 shadow-[0_20px_50px_rgba(31,38,135,0.25)] hover:shadow-[0_25px_70px_rgba(59,130,246,0.35)] hover:-translate-y-1"
//           : "bg-white shadow-xl"
//       }`}
//     >

//       {/* 🔵 Header */}
//         <div
//           className={`relative min-h-[170px] bg-gradient-to-br ${theme.gradient} bg-[length:200%_200%] animate-gradientMove`}
//           style={{
//             clipPath: "polygon(0 0, 100% 0, 100% 70%, 0 100%)",
//           }}
//         >
//           <div className="p-2 text-white flex flex-col h-full">

//             {/* Top Row → Title + Claims */}
//             <div className="flex justify-between items-start gap-2">
              
//               <div className="text-sm font-bold uppercase leading-tight break-words line-clamp-2 flex-1">
//                 {product.name}
//               </div>

//               <div
//                 className={`text-white text-sm px-2 py-1 rounded-md font-semibold whitespace-nowrap ${
//                   isRetailerMobile
//                     ? `${theme.badge} shadow-lg`
//                     : "bg-emerald-500"
//                 }`}
//               >
//                 {product.claims} Claims
//               </div>
//             </div>

//             {/* Category */}
//             <div className="text-sm opacity-80 mt-2 mb-2">
//               {category?.name}
//             </div>

//             {/* Validity */}
//             <div className="mt-auto text-">
//               <span className="bg-white/20 px-2 py-1 rounded-md backdrop-blur-sm font-semibold text-xs">
//                 {product.validity} Days Validity
//               </span>
//             </div>

//           </div>
//         </div>


//       {/* ⚫ Price Circle */}
//       <div className="absolute top-20 left-1/2 -translate-x-1/2 z-10">
//         {isRetailerMobile && (
//           <div className="absolute inset-0 w-24 h-24 -translate-x-1 -translate-y-1 rounded-full bg-blue-500 blur-2xl opacity-40 animate-pulse"></div>
//         )}
//         <div
//           className={`w-20 h-20 rounded-full bg-slate-900 text-white flex flex-col items-center justify-center shadow-lg border-[4px] border-dashed ${theme.accent}`}
//         >
//           <div className="text-lg font-extrabold">
//             {product.is_percent === 1
//               ? `${product.mrp}%`
//               : `₹${product.mrp}`}
//           </div>
//           <div className="text-[9px] uppercase opacity-80">
//             {product.is_percent === 1 ? "Rate" : "MRP"}
//           </div>
//         </div>
//       </div>

//       {/* ⚪ Body */}
//       <div
//         className={`pt-5 px-4 pb-6 space-y-3 text-sm ${
//           isRetailerMobile ? "text-white" : ""
//         }`}
//       >

//         {/* 💰 Value Range + Profit */}
//         <div className="grid grid-cols-2 gap-2">
//           <Info
//             label="Value Range"
//             value={`₹${product.min_value} - ₹${product.max_value}`}
//             isRetailerMobile={isRetailerMobile}
//           />
//           <Info
//             label="Profit"
//             value={
//               product.is_percent === 1
//                 ? `${product.margin}%`
//                 : `₹${product.margin}`
//             }
//             isRetailerMobile={isRetailerMobile}
//           />
//         </div>

//         {/* Features */}
//         {features.length > 0 && (
//           <Section title="Features" isRetailerMobile={isRetailerMobile}>
//             {(showAllFeatures
//               ? features
//               : features.slice(0, FEATURE_LIMIT)
//             ).map((f, i) => (
//               <li key={i} className="flex gap-1">
//                 <span>{f}</span>
//               </li>
//             ))}

//             {features.length > FEATURE_LIMIT && (
//               <button
//                 onClick={() => setShowAllFeatures(!showAllFeatures)}
//                 className="text-sm mt-1 text-blue-600 font-semibold"
//               >
//                 {showAllFeatures ? "View Less" : "View More"}
//               </button>
//             )}
//           </Section>
//         )}

//         {/* Coverage */}
//         {coverage.length > 0 && (
//           <Section title="Coverage" isRetailerMobile={isRetailerMobile}>
//             {(showAllCoverage
//               ? coverage
//               : coverage.slice(0, COVERAGE_LIMIT)
//             ).map((c, i) => (
//               <li key={i} className="flex gap-1">
//                 <span className={`${theme.check} font-bold`}>✓</span>
//                 <span>{c}</span>
//               </li>
//             ))}

//             {coverage.length > COVERAGE_LIMIT && (
//               <button
//                 onClick={() => setShowAllCoverage(!showAllCoverage)}
//                 className="text-sm mt-1 text-blue-600 font-semibold"
//               >
//                 {showAllCoverage ? "View Less" : "View More"}
//               </button>
//             )}
//           </Section>
//         )}

        

//         {/* Exclusions */}
//         {/* {exclusions.length > 0 && (
//           <Section title="Exclusions">
//             {exclusions.map((e, i) => (
//               <li key={i} className="flex gap-1 text-red-600">
//                 <span>✕</span>
//                 <span>{e}</span>
//               </li>
//             ))}
//           </Section>
//         )} */}
//       </div>

//       {/* Bottom Angle */}
//       <div
//         className={`absolute bottom-0 right-0 w-20 h-14 bg-gradient-to-tr ${theme.gradient}`}
//         style={{
//           clipPath: "polygon(30% 0, 100% 0, 100% 100%, 0 100%)",
//         }}
//       />
//     </div>

//     </motion.div>
//   );
// }

// /* Compact Info Box */
// function Info({ label, value, isRetailerMobile }) {
//   return (
//     <div
//       className={` rounded-md p-1.5 ${
//         isRetailerMobile
//           ? "glass-small-card bg-white/10 border border-white/20 text-black"
//           : "bg-slate-50 border border-slate-200"
//       }`}
//     >
//       <div className={`text-[9px] font-semibold ${
//         isRetailerMobile ? "text-black/70" : "text-slate-500"
//       }`}>
//         {label}
//       </div>

//       <div className={`text-sm font-semibold ${
//         isRetailerMobile ? "text-black" : "text-slate-900"
//       }`}>
//         {value}
//       </div>
//     </div>
//   );
// }

// /* Section */
// function Section({ title, children, isRetailerMobile }) {
//   return (
//     <div>
//       <div
//         className={`text-sm font-bold mb-1 ${
//           isRetailerMobile ? "text-black/80" : "text-slate-700"
//         }`}
//       >
//         {title}
//       </div>

//       <ul
//         className={`space-y-0.5 text-[11px] ${
//           isRetailerMobile ? "text-black/70" : "text-slate-600"
//         }`}
//       >
//         {children}
//       </ul>
//     </div>
//   );
// }

// export default function RetailerProductView() {
//   const [loading, setLoading] = useState(false);
//   const [products, setProducts] = useState([]);

//   const authUserString = localStorage.getItem("authUserData");
//   const authUser = authUserString ? JSON.parse(authUserString) : null;
//   const companyId = authUser?.company_id;

//   const { user } = useContext(AuthContext);

// const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

// useEffect(() => {
//   const handleResize = () => {
//     setIsMobile(window.innerWidth < 640);
//   };

//   window.addEventListener("resize", handleResize);
//   return () => window.removeEventListener("resize", handleResize);
// }, []);

// const isRetailerMobile =
//   Number(user?.role) === 5 && isMobile;

  

//   useEffect(() => {
//     async function fetchProducts() {
//       if (!companyId) return;

//       setLoading(true);
//       try {
//         const res = await axios.get(
//           `${BASE_URL}warranty/company-products`,
//           { params: { company_id: companyId } }
//         );

//         const companyBlock = res.data?.data?.[0];
//         const mapped =
//           companyBlock?.products?.map((cp) => ({
//             company_product_id: cp.company_product_id,
//             margin: cp.margin,
//             ...cp.product,
//           })) || [];

//         setProducts(mapped);
//       } catch (e) {
//         console.error("Company products error", e);
//       } finally {
//         setLoading(false);
//       }
//     }

//     fetchProducts();
//   }, [companyId]);

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center py-10 text-sm text-slate-600">
//         Loading products…
//       </div>
//     );
//   }

//   return (
//     <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
//       {products.map((p) => (
//         <ProductCard
//           key={p.company_product_id}
//           product={p}
//           isRetailerMobile={isRetailerMobile}
//         />
//       ))}
//     </div>
//   );
// }


